import { IMAGES } from "../lib/site";

export const SERVICE_PAGES = {
  sensors: {
    path: "/sensors",
    seoTitle: "حساسات الكفرات بالرياض | بيع حساسات ضغط الإطارات TPMS",
    seoDesc:
      "بيع حساسات ضغط الكفرات TPMS في الرياض: حساسات أصلية وبديلة وقابلة للبرمجة حسب التوفر. نساعدك في اختيار الحساس المتوافق مع سيارتك. استفسر عبر واتساب.",
    h1: "حساسات الكفرات (TPMS) في الرياض",
    intro:
      "نوفر حساسات ضغط الإطارات بفئات متعددة — أصلية وبديلة وقابلة للبرمجة حسب التوفر — مع التحقق من التوافق مع موديل سيارتك وسنة صنعها ونوع نظامها قبل أي طلب.",
    points: [
      "حساسات أصلية حسب مواصفات الوكالة عند توفرها",
      "حساسات بديلة عالية الجودة بخيارات منافسة",
      "حساسات عالمية قابلة للبرمجة لعدد واسع من الموديلات",
      "صمامات معدنية ومطاطية وعدد صيانة للحساسات",
      "التأكد من التردد والبروتوكول المناسب لسيارتك قبل التوريد",
    ],
    image: IMAGES.sensorOem,
    imageAlt: "حساس ضغط إطارات أصلي TPMS بتردد 433MHz مع صمام معدني",
  },
  programming: {
    path: "/programming",
    seoTitle: "برمجة حساسات الكفرات بالرياض | برمجة حساس ضغط الإطارات TPMS",
    seoDesc:
      "برمجة حساسات الكفرات TPMS في الرياض وإعادة تعلم النظام (Relearn) بعد تبديل الكفرات أو الحساسات. أرسل بيانات سيارتك عبر واتساب.",
    h1: "برمجة حساسات TPMS",
    intro:
      "بعد تركيب حساس جديد أو تدوير الكفرات تحتاج معظم السيارات إلى برمجة أو إعادة تعلم حتى تتعرف وحدة السيارة على الحساسات وتظهر القراءات بشكل صحيح — وهذا تخصصنا.",
    points: [
      "برمجة الحساسات القابلة للبرمجة على نظام سيارتك",
      "إعادة تعلم النظام (Relearn) بعد تبديل أو تدوير الكفرات",
      "مطابقة التردد والبروتوكول مع وحدة السيارة",
      "معالجة استمرار لمبة تحذير ضغط الإطارات بعد التركيب",
      "التحقق من القراءات بعد البرمجة",
    ],
    image: IMAGES.dashboard,
    imageAlt: "شاشة عدادات رقمية تعرض بيانات ضغط الإطارات",
  },
  replacement: {
    path: "/replacement",
    seoTitle: "استبدال وتغيير حساس الكفر بالرياض | حساسات TPMS",
    seoDesc:
      "استبدال حساسات الكفرات التالفة في الرياض واختيار البديل المناسب حسب التوافق، مع فحص الصمامات ومعالجة التسريب. استفسر عبر واتساب.",
    h1: "استبدال حساسات الكفرات",
    intro:
      "عند تلف الحساس أو نفاد بطاريته، نساعدك في اختيار البديل المناسب حسب توافق سيارتك، مع استبدال الصمام وعدد الصيانة عند الحاجة لتجنب تسريب الهواء.",
    points: [
      "استبدال الحساسات التالفة أو منتهية البطارية",
      "اختيار البديل المناسب: أصلي أو بديل أو قابل للبرمجة",
      "فحص واستبدال الصمامات المعدنية والمطاطية",
      "الترصين وضبط ضغط الهواء بعد التركيب",
      "برمجة الحساس الجديد والتحقق من اختفاء التحذير",
    ],
    image: IMAGES.sensorRemoval,
    imageAlt: "فك حساس ضغط الإطار التالف من داخل الجنط أثناء الخدمة",
  },
  inspection: {
    path: "/inspection",
    seoTitle: "فحص حساسات الكفرات بالرياض | فحص حساسات ضغط الإطارات",
    seoDesc:
      "فحص حساسات ضغط الإطارات TPMS في الرياض وتحديد أسباب تعطل الحساس أو ظهور تحذير ضغط الإطارات بأجهزة قراءة متخصصة.",
    h1: "فحص حساسات الكفرات",
    intro:
      "لمبة التحذير لا تعني دائمًا حساسًا تالفًا. بأجهزة قراءة متخصصة نفحص حالة كل حساس وبطاريته وتردده لنحدد السبب الحقيقي قبل أي استبدال.",
    points: [
      "قراءة حالة الحساس ومستوى البطارية بجهاز فحص متخصص",
      "تحديد سبب ظهور تحذير ضغط الإطارات",
      "التمييز بين تلف الحساس ومشاكل الضغط الفعلية",
      "فحص التردد والبروتوكول ومطابقتها للنظام",
      "تقرير واضح بالحالة والخيارات قبل أي إجراء",
    ],
    image: IMAGES.diagTool,
    imageAlt: "جهاز فحص وتشخيص محمول يتواصل مع وحدة السيارة",
  },
};
